import React, { useEffect, useState,useContext } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import './Home.css';
import Topbar from "../../Topbar";
import Footer from "../../Footer";
import Image from 'react-bootstrap/Image';
import Dropdown from 'react-bootstrap/Dropdown';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import { Link, useNavigate } from 'react-router-dom';
import loader from '../../../assests/loader.gif';
import API from '../../../Utils/Api';
import { LocationContext } from "./../../LocationContext";

/*const options = [
    { label: 'All', value: 'option1', image: '../assets/images/discounticn.webp' },
    { label: 'Free', value: 'option2', image: '../assets/images/esdicn.webp' },
    { label: 'Retails', value: 'option3', image: '../assets/images/sddicn.webp' },
    { label: 'Services', value: 'option4', image: '../assets/images/fiicn.webp' },
    { label: 'Fitness & Health', value: 'option5', image: '../assets/images/fiicn.webp' },
    { label: 'Dining', value: 'option6', image: '../assets/images/fiicn.webp' },
    { label: 'Salon & Parlors', value: 'option7', image: '../assets/images/fiicn.webp' },
    { label: 'Education/Coaching', value: 'option8', image: '../assets/images/fiicn.webp' },
    { label: 'Entertainment', value: 'option9', image: '../assets/images/fiicn.webp' },
    { label: 'Other', value: 'option10', image: '../assets/images/fiicn.webp' },
];*/

/*const optionscheck = [
    { label: 'All', value: 'opt1', image: '../assets/images/discounticn.webp' },
    { label: 'Grocery', value: 'opt2', image: '../assets/images/esdicn.webp' },
    { label: 'Fashion/Apparel', value: 'opt3', image: '../assets/images/sddicn.webp' },
    { label: 'Electronics', value: 'opt4', image: '../assets/images/fiicn.webp' },
    { label: 'Kitechenware', value: 'opt5', image: '../assets/images/fiicn.webp' },
    { label: 'Furniture', value: 'opt6', image: '../assets/images/fiicn.webp' },
    { label: 'Stationary', value: 'opt7', image: '../assets/images/fiicn.webp' },
    { label: 'Baby/Kids', value: 'opt8', image: '../assets/images/fiicn.webp' },
    { label: 'Gifts', value: 'opt9', image: '../assets/images/fiicn.webp' },
    { label: 'More', value: 'opt10', image: '../assets/images/fiicn.webp' },
];*/



const Home = () => {
    const navigate = useNavigate();

    const { cur_location,locationChangedByUser } = useContext(LocationContext);

    const [loading, setLoading] = useState(true);
    const [deal, setDeal] = useState([]);
    const [exclusivedeal, setExclusivedeal] = useState([]);
    const [banners, setBanners] = useState([]);

    const [current_page, setCurrentpage] = useState(1);
    const [last_page, setLastpage] = useState(1);
    const [sortby, setSortby] = useState('');
    const [cat, setCat] = useState([]);

    const [keyword, setKeyword] = useState('');
    //const [month, setMonth] = useState('');

    const [step, setStep] = useState(false);

    const [nearbycitystatus, setNearbycitystatus] = useState(0);
    
    const [filter, setFilter] = useState('');

    const [homepagetagline, setHomepagetagline] = useState('');

    useEffect(() => {
        document.title = `Home | Local Bells`;
        document.getElementById('bodywrap').className = 'nehome';


        localStorage.setItem("page", 0);

        API.post('get_settings')
          .then(response => {
              
              if (response.data.status === false) {

              } else {
                  setHomepagetagline(response.data.data.home_page_tag_line);
              }
          }).catch(error => {
              
          });


         API.post('get_all_category')
            .then(response => {
                setLoading(false);
                if (response.data.status === false) {

                } else {
                    setCat(response.data.data);
                }
            }).catch(error => {
                setLoading(false);
            });

        /* Start get deal */
        let formData = new FormData();
        formData.append(`per_page`, 8);
        formData.append(`location_pincode`, '');
        formData.append(`location_town`, '');
        formData.append(`location_filter_type`, 1);
         const saved = sessionStorage.getItem("cur_location");
        if(saved)
         {
            var saved1=JSON.parse(saved);
            if(saved1.lat!=='' && saved1.lng!=='')
            {
                formData.append(`latitude`, saved1.lat);
                formData.append(`longitude`, saved1.lng);
            }else{
                if(saved1.town_id!=='')
                {
                    formData.append(`town_id`, saved1.town_id);
                }
                
            }
        }
        var url = 'get_deal';
        if (localStorage.getItem("token")) {
            url = 'get_deal_with_login';
        }
        //formData.append('location_id', localStorage.getItem('location_id') || '');
        API.post(url, formData)
            .then(response => {
                setLoading(false);
                if (response.data.status === false) {

                } else {
                    //setMonth(response.data.data.current_month);
                    setLastpage(response.data.data.pagination.last_page);
                    setDeal(response.data.data.deal);
                    setExclusivedeal(response.data.data.exclusive_deal);
                    setBanners(response.data.data.banners);
                    setNearbycitystatus(response.data.data.near_by_city_status);
                }
            }).catch(error => {
                setLoading(false);
            });
        /* End get deal */
    }, []);


   const loadHomeData= () =>{
        let formData = new FormData();
        formData.append(`per_page`, 8);
        formData.append(`keyword`, '');
        formData.append(`type`, sortby);
        formData.append(`deal_type_filter`, filter);
        formData.append(`category`, '');
        formData.append(`subcategory`, '');
        formData.append(`location_filter_type`, 1);
        if(cur_location.lat!=='' && cur_location.lng!=='')
        {
            formData.append(`latitude`, cur_location.lat);
            formData.append(`longitude`, cur_location.lng);
        }else{
            if(cur_location.town_id!=='')
            {
                formData.append(`town_id`, cur_location.town_id);
            } 
        }
        
        var url = 'get_deal';
        if (localStorage.getItem("token")) {
            url = 'get_deal_with_login';
        }
        API.post(url, formData)
            .then(response => {
                setLoading(false);
                if (response.data.status === false) {

                } else {
                   setCurrentpage(1);
                     setLastpage(response.data.data.pagination.last_page);
                    setDeal(response.data.data.deal);
                    setExclusivedeal(response.data.data.exclusive_deal);
                    setNearbycitystatus(response.data.data.near_by_city_status);
                    setBanners(response.data.data.banners);
                }
            }).catch(error => {
                setLoading(false);
            });
   };
useEffect(() => { 
    if (locationChangedByUser) {
        setLoading(true);
        setStep(false);
      loadHomeData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, [locationChangedByUser,cur_location]);  
    var adsetting = {
        dots: true,
        arrow: false,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,              // Enable autoplay
        autoplaySpeed: 3000,         // Set the speed for autoplay (in milliseconds)
        centerMode: false,            // Enable center mode    
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    };

    var exdealsetting = {
        dots: true,
        arrow: false,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: false,              // Enable autoplay
        autoplaySpeed: 3000,         // Set the speed for autoplay (in milliseconds)
        centerMode: false,            // Enable center mode    
        responsive: [
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2.1,
                    slidesToScroll: 1,
                    infinite: false,   // Optional: prevents looping, can be true
                    centerMode: false,
                    arrows: false,
                    dots: true
                }
            }
        ]
    };


    const [selected, setSelected] = useState(0);
    const handleChange = (event) => {
        setSelected(event.target.value);
    };


    const getdeal = () => {
        setLoading(true);
        var currentpage = current_page + 1;
        let formData = new FormData();
        formData.append(`per_page`, 8);
        formData.append(`page`, currentpage);
        formData.append(`keyword`, '');
        formData.append(`type`, sortby);
        formData.append(`deal_type_filter`, filter);
        formData.append(`category`, '');
        formData.append(`subcategory`, '');
        if(step===true)
        {
            formData.append(`location_filter_type`, 0);
        }else{
            formData.append(`location_filter_type`, 1);
        }
        if(cur_location.lat!=='' && cur_location.lng!=='')
        {
            formData.append(`latitude`, cur_location.lat);
            formData.append(`longitude`, cur_location.lng);
        }else{
            if(cur_location.town_id!=='')
            {
                formData.append(`town_id`, cur_location.town_id);
            }
            if(step===true)
            {
              if(cur_location.city_id!=='')
                {
                    formData.append(`city_id`, cur_location.city_id);
                }  
            }
        }
        var url = 'get_deal';
        if (localStorage.getItem("token")) {
            url = 'get_deal_with_login';
        }
        //formData.append('location_id', localStorage.getItem('location_id') || '');
        API.post(url, formData)
            .then(response => {
                setLoading(false);
                if (response.data.status === false) {

                } else {
                    setCurrentpage(currentpage);
                    setLastpage(response.data.data.pagination.last_page);
                    setDeal(prevDeals => [...prevDeals, ...response.data.data.deal]);
                }
            }).catch(error => {
                setLoading(false);
            });
    }
    const setSortBy = (val) => {
        setStep(false);
        setSortby(val);
        setCurrentpage(1)
        setLoading(true);
        let formData = new FormData();
        formData.append(`per_page`, 8);
        formData.append(`page`, 1);
        formData.append(`keyword`, '');
        formData.append(`type`, val);
        formData.append(`deal_type_filter`, filter);
        formData.append(`category`, '');
        formData.append(`subcategory`, '');
        formData.append(`location_filter_type`, 1);
        if(cur_location.lat!=='' && cur_location.lng!=='')
        {
            formData.append(`latitude`, cur_location.lat);
            formData.append(`longitude`, cur_location.lng);
        }else{
            if(cur_location.town_id!=='')
            {
                formData.append(`town_id`, cur_location.town_id);
            }
            
        }
        var url = 'get_deal';
        if (localStorage.getItem("token")) {
            url = 'get_deal_with_login';
        }
        //formData.append('location_id', localStorage.getItem('location_id') || '');
        API.post(url, formData)
            .then(response => {
                setLoading(false);
                if (response.data.status === false) {

                } else {
                    setLastpage(response.data.data.pagination.last_page);
                    setDeal(response.data.data.deal);
                }
            }).catch(error => {
                setLoading(false);
            });

    }
    const page_deal = (id) => {
        window.location.href = "/deal?id=" + id;
    }
    /* Start Value set */
    const handleInputChange = (event) => {
        event.persist();
        setKeyword(event.target.value);
    }
    /* End Value set */
    const search = () => {
        window.location.href = "/deal?keyword=" + keyword;
    }

    const handleLikeDislike = (eventKey, dealId, type) => {

        if (!localStorage.getItem("token")) {
            navigate('/neighbour/login');
            return;
        }

        let formData = new FormData();
        formData.append('deal_id', dealId);
        formData.append('type', type);
        formData.append('like_dislike_id', eventKey);
        
        var url = 'deal_like_dislike_by_user';

        API.post(url, formData)
            .then(response => {
                if (response.data.status === false) {

                } else {
                    // console.log('Like success '+ response.data.data.total_like);
                    // console.log('Dislike success '+ response.data.data.total_dis_like);

                    setDeal(prevDeals =>
                        prevDeals.map(deal =>
                            deal.deal_id === dealId
                                ? {
                                    ...deal,
                                    is_liked: response.data.data.is_liked,
                                    is_dis_liked: response.data.data.is_dis_liked,
                                    total_like: response.data.data.total_like,
                                    total_dis_like: response.data.data.total_dis_like,
                                    like: response.data.data.like,
                                    dislike: response.data.data.dislike,
                                }
                                : deal
                        )
                    );

                    setExclusivedeal(prevDeals =>
                        prevDeals.map(deal =>
                            deal.deal_id === dealId
                                ? {
                                    ...deal,
                                    is_liked: response.data.data.is_liked,
                                    is_dis_liked: response.data.data.is_dis_liked,
                                    total_like: response.data.data.total_like,
                                    total_dis_like: response.data.data.total_dis_like,
                                    like: response.data.data.like,
                                    dislike: response.data.data.dislike,
                                }
                                : deal
                        )
                    );

                }
            }).catch(error => {
                setLoading(false);
                console.error('Error :', error);
            });
    };

    
const getNearby = () => {
        setStep(true);
        setLoading(true);
        let formData = new FormData();
        formData.append(`per_page`, 8);
        formData.append(`page`, 1);
        formData.append(`location_filter_type`, 0);
        formData.append(`type`, sortby);
        formData.append(`deal_type_filter`, filter);
        if(cur_location.lat!=='' && cur_location.lng!=='')
        {
            formData.append(`latitude`, cur_location.lat);
            formData.append(`longitude`, cur_location.lng);
        }else{
            if(cur_location.town_id!=='')
            {
                formData.append(`town_id`, cur_location.town_id);
            }
            if(cur_location.city_id!=='')
            {
                formData.append(`city_id`, cur_location.city_id);
            }
        }  
       
        var url = 'get_deal';
        if (localStorage.getItem("token")) {
            url = 'get_deal_with_login';
        }
        //formData.append('location_id', localStorage.getItem('location_id') || '');
        API.post(url, formData)
            .then(response => {
                setLoading(false);
                if (response.data.status === false) {

                } else {
                    setCurrentpage(1);
                    setLastpage(response.data.data.pagination.last_page);
                    setDeal(prevDeals => [...prevDeals, ...response.data.data.deal]);
                }
            }).catch(error => {
                setLoading(false);
            });

    }

const setFilters = (val) => {
    setLoading(true);
    setCurrentpage(1)
    setFilter(val);

    var currentpage = 1;
    let formData = new FormData();
    formData.append(`per_page`, 8);
    formData.append(`keyword`, '');
    formData.append(`type`, sortby);
    formData.append(`deal_type_filter`, val);
    formData.append(`category`, '');
    formData.append(`subcategory`, '');
    formData.append(`location_filter_type`, 1);
    if(cur_location.lat!=='' && cur_location.lng!=='')
        {
            formData.append(`latitude`, cur_location.lat);
            formData.append(`longitude`, cur_location.lng);
        }else{
            if(cur_location.town_id!=='')
            {
                formData.append(`town_id`, cur_location.town_id);
            }
        }
    var url = 'get_deal';
    if (localStorage.getItem("token")) {
        url = 'get_deal_with_login';
    }
    //formData.append('location_id', localStorage.getItem('location_id') || '');
    API.post(url, formData)
        .then(response => {
            setLoading(false);
            if (response.data.status === false) {

            } else {
                setCurrentpage(currentpage);
                setLastpage(response.data.data.pagination.last_page);
                setDeal(response.data.data.deal);
            }
        }).catch(error => {
            setLoading(false);
        });
}
const red_url = (url) => {
  if (url && url !== "") {
    window.location.href = url;
  }
};
    return (
        <>
            <Topbar />
            <section className="main-cont-box">
                <Container>
                    <Row>
                        <Col md={12} lg={12} xl={12} xxl={12} className='main-cont-box-right'>
                            {/* <Header toggleSidebar={toggleSidebar} /> */}
                            <div className='nei-cont'>

                                <Row className='ldsearch'>
                                    <Col md={12}>
                                        <InputGroup className="mb-3">
                                            <InputGroup.Text id="search" className='lds-left'>
                                                <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/search.webp'} className="img-fluid" alt="search" />
                                            </InputGroup.Text>
                                            <Form.Control
                                                placeholder="Search for deals"
                                                aria-label="search"
                                                aria-describedby="search"
                                                name="keyword"
                                                onChange={handleInputChange} value={keyword}
                                            />
                                            <InputGroup.Text id="search" className='lds-right'>
                                                <Button onClick={search}>
                                                    <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/search-wh.webp'} className="img-fluid" alt="search" />
                                                </Button>
                                            </InputGroup.Text>
                                        </InputGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <div className="gap-3 mb-4 ld-filter-main">
                                            <div className="d-flex gap-3 align-items-center justify-content-center lfm-cat overflow-x-scroll">
                                                <div className='gap-3 d-flex ld-filter-box '>
                                                    <label
                                                        key={0}
                                                        className={selected === 0 ? 'active' : ''}
                                                    >
                                                        <input
                                                            type="radio"
                                                            name="custom-radio"
                                                            value={0}
                                                            className="d-none"
                                                            checked={selected === 0}
                                                        />
                                                        <Button
                                                            variant={'gen'}
                                                            className={''}
                                                            
                                                        >
                                                            All
                                                        </Button>
                                                    </label>
                                                    {cat.map((option) => {
                                                        const isSelected = selected === option.value;
                                                        const isNotAll = option.value !== 'option1';

                                                        const isActive = isSelected && isNotAll;

                                                        return (
                                                            <label
                                                                key={option.value}
                                                                className={isActive ? 'active' : ''}
                                                            >
                                                                <input
                                                                    type="radio"
                                                                    name="custom-radio"
                                                                    value={option.value}
                                                                    checked={isSelected}
                                                                    onChange={handleChange}
                                                                    className="d-none"
                                                                />
                                                                <Button
                                                                    variant={isSelected ? 'act' : 'gen'}
                                                                    className={isActive ? 'active' : ''}
                                                                    onClick={() => page_deal(option.id)}
                                                                >
                                                                    {option.name}
                                                                </Button>
                                                            </label>
                                                        );
                                                    })}
                                                </div>
                                            </div>

                                        </div>
                                    </Col>
                                </Row>
                                <h3 className="hm-head">{homepagetagline} <span className="org-txt">{cur_location.single_address}</span></h3>
                                {banners.length > 0 ? (
                                <div className='ld-ad-banner'>
                                    {banners.length === 1 ? (
                                        <Link to={banners[0].url && banners[0].url !== "" ? banners[0].url : "#"}>
                                        <Image
                                            src={banners[0].image}
                                            className="img-fluid"
                                            alt="ad-banner"
                                        />
                                        </Link>
                                    )  : (
                                        <Slider {...adsetting}>
                                            {banners.map((val, index) => ( 
                                                <Image key={index} src={val.image} className="img-fluid banner-slider-img" alt="ad-banner" onClick={() => red_url(val.url)}  />
                                            ))}
                                        </Slider>
                                    )}

                                </div>
                                ) : null}
                                

                                {/*<h3 className="hm-head">Only place to find <span className="blue-txt">Local Deals, Discounts</span> and <span className="blue-txt">Sale</span> in <span className="org-txt">{cur_location.single_address}</span></h3>*/}

                                {exclusivedeal.length > 0 && (
                                    <>
                                        {/*{localStorage.getItem('location_town') !== null ? (
                                            <h5 className='fw-500 mb-3 mt-3'>
                                                Top Local Discounts in {cur_location.single_address} for August Month
                                            </h5>
                                        ) : (
                                            <h5 className='fw-500 mb-3 mt-3'>
                                                Top Local Discounts for {month} Month
                                            </h5>
                                        )}*/}

                                        

                                        <div className='ld-ed-box mt-4'>
                                            <div className='vm-main mb-3'>
                                                <h6 className='fw-500'>Exclusive Deal</h6>
                                                <Link to="/exclusive-deal" className="vm-link">View More</Link>
                                            </div>
                                            {exclusivedeal.length > 1 ? (
                                                <Slider {...exdealsetting}>
                                                    {exclusivedeal.map((val, index) => {
                                                        const isEven = index % 2 === 0; // even index
                                                        return (
                                                            <Col xs={6} sm={6} md={4} lg={6} xl={4} xxl={3} className='cd-single-main'>
                                                                <div className='cd-single-box'>
                                                                    {val.deal_tag && (
                                                                        isEven ? (
                                                                            <span className="user-org-label">{val.deal_tag}</span>
                                                                        ) : (
                                                                            <span className="user-org-label">{val.deal_tag}</span>
                                                                        )
                                                                    )}
                                                                    <Link to={`/neighbour/deal-details/${val.deal_id}`}>
                                                                        {/* <Image src={val.image} className="img-fluid" alt="cdeal1" />
                                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/placeimage.png'} className="img-fluid" alt="cdeal5" /> */}
                                                                        <Image 
                                                                            src={val.image && val.image !== "" ? val.image : process.env.REACT_APP_BASE_URL + 'assets/images/nif.jpg'} 
                                                                            className="img-fluid" 
                                                                            alt="cdeal" 
                                                                        /> 

                                                                        {/* bmd-img */}
                                                                        <div>
                                                                            <h6><Link to={`/neighbour/business-details/${val.slug}`}><span className='text-primary'>{val.business_name}</span></Link></h6>
                                                                            {(() => {
                                                                                if (val.deal_master_type === 'specific') {
                                                                                    if (val.deal_type === 1) {
                                                                                        return (<div className='d-flex align-center csb-title'>
                                                                                            <div className='d-flex'><strike className="me-2"><h5>₹ {val.original_mrp}</h5></strike><h5>₹ {val.sale_price}</h5></div>
                                                                                            <h6 class="peroff">{val.discount}% off</h6>
                                                                                        </div>)
                                                                                    } else if (val.deal_type === 2) {
                                                                                        return (<div className='d-flex align-center csb-title'>
                                                                                            <div className='d-flex'><h5>Buy {val.buy_qty} Get {val.get_qty}</h5></div>
                                                                                        </div>)
                                                                                    }
                                                                                } else if (val.deal_master_type === 'general') {
                                                                                    if (val.deal_type === 3) {
                                                                                        return (<div className='d-flex align-center csb-title'>
                                                                                            <div className='d-flex'><h5>{val.store_percent_discount}% OFF</h5></div>
                                                                                        </div>)
                                                                                    } else if (val.deal_type === 4) {
                                                                                        return (<div className='d-flex align-center csb-title'>
                                                                                            <div className='d-flex'><h5>{val.store_cash_discount} OFF</h5></div>
                                                                                        </div>)
                                                                                    }
                                                                                } else if (val.deal_master_type === 'free') {
                                                                                    return (<div className='d-flex align-center csb-title'>
                                                                                        <div className='d-flex'><h5 className="text-danger">{val.free_item}</h5></div>
                                                                                    </div>)
                                                                                }
                                                                            })()}
                                                                            <div className="title-box"><h5>{val.listing_title}</h5></div>
                                                                            <div className='cd-loc mt-2'>
                                                                                <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/pinpoint.webp'} className="img-fluid" alt="pinpoint" />
                                                                                <h6>{val.address}</h6>
                                                                            </div>
                                                                        </div>
                                                                    </Link>
                                                                    <div className='dd-ld-box cd-ld-box'>
                                                                        <Dropdown drop="up" onSelect={(eventKey) => handleLikeDislike(eventKey, val.deal_id, 'like')}>
                                                                            <Dropdown.Toggle className={`dd-like-box ${val.is_liked ? "like-box-bg" : "dlike-box-bg"}`} variant="success" id="dropdown-like">
                                                                                <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/like.webp'} className="img-fluid" alt="like" />
                                                                                <h6>{val.total_like}</h6>
                                                                            </Dropdown.Toggle>

                                                                            <Dropdown.Menu className='dd-like-drop'>
                                                                                {val.like.map((val1, index1) => {
                                                                                    return (
                                                                                        <Dropdown.Item className={val1.is_liked ? 'active-like' : ''} eventKey={val1.id}><div><Image src={process.env.REACT_APP_BASE_URL + 'assets/images/like.webp'} className="img-fluid" alt="like" /> {val1.name} </div><span>{val1.like_count}</span></Dropdown.Item>
                                                                                    );
                                                                                })}
                                                                            </Dropdown.Menu>
                                                                        </Dropdown>
                                                                        <Dropdown drop="up" onSelect={(eventKey) => handleLikeDislike(eventKey, val.deal_id, 'dislike')}>
                                                                            <Dropdown.Toggle className={`dd-dislike-box ${val.is_dis_liked ? "like-box-bg" : "dlike-box-bg"}`} variant="success" id="dropdown-dislike">
                                                                                <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/dislike.webp'} className="img-fluid" alt="dislike" />
                                                                                <h6>{val.total_dis_like}</h6>
                                                                            </Dropdown.Toggle>
                                                                            <Dropdown.Menu className='dd-dislike-drop'>
                                                                                {val.dislike.map((val1, index1) => {
                                                                                    return (
                                                                                        <Dropdown.Item className={val1.is_disliked ? 'active-dislike' : ''} eventKey={val1.id}><div><Image src={process.env.REACT_APP_BASE_URL + 'assets/images/dislike.webp'} className="img-fluid" alt="dislike" /> {val1.name} </div><span>{val1.like_count}</span></Dropdown.Item>
                                                                                    );
                                                                                })}
                                                                            </Dropdown.Menu>
                                                                        </Dropdown>
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                        );
                                                    })}
                                                </Slider>
                                            ) : (
                                                exclusivedeal.map((val, index) => {
                                                    const isEven = index % 2 === 0; // even index
                                                    return (
                                                        <Col xs={6} sm={6} md={4} lg={6} xl={4} xxl={3} className='cd-single-main'>
                                                            <div className='cd-single-box'>
                                                                {val.deal_tag && (
                                                                    isEven ? (
                                                                        <span className="user-org-label">{val.deal_tag}</span>
                                                                    ) : (
                                                                        <span className="user-org-label">{val.deal_tag}</span>
                                                                    )
                                                                )}
                                                                <Link to={`/neighbour/deal-details/${val.deal_id}`}>
                                                                    {/* <Image src={val.image} className="img-fluid" alt="cdeal1" /> */}
                                                                    <Image 
                                                                        src={val.image && val.image !== "" ? val.image : process.env.REACT_APP_BASE_URL + 'assets/images/nif.jpg'} 
                                                                        className="img-fluid" 
                                                                        alt="cdeal" 
                                                                    />                                                                     
                                                                    <div>
                                                                        <h6><Link to={`/neighbour/business-details/${val.slug}`}><span className='text-primary'>{val.business_name}</span></Link></h6>
                                                                        {(() => {
                                                                            if (val.deal_master_type === 'specific') {
                                                                                if (val.deal_type === 1) {
                                                                                    return (<div className='d-flex align-center csb-title'>
                                                                                        <div className='d-flex'><strike className="me-2"><h5>₹ {val.original_mrp}</h5></strike><h5>₹ {val.sale_price}</h5></div>
                                                                                        <h6 class="peroff">{val.discount}% off</h6>
                                                                                    </div>)
                                                                                } else if (val.deal_type === 2) {
                                                                                    return (<div className='d-flex align-center csb-title'>
                                                                                        <div className='d-flex'><h5>Buy {val.buy_qty} Get {val.get_qty}</h5></div>
                                                                                    </div>)
                                                                                }
                                                                            } else if (val.deal_master_type === 'general') {
                                                                                if (val.deal_type === 3) {
                                                                                    return (<div className='d-flex align-center csb-title'>
                                                                                        <div className='d-flex'><h5>{val.store_percent_discount}% OFF</h5></div>
                                                                                    </div>)
                                                                                } else if (val.deal_type === 4) {
                                                                                    return (<div className='d-flex align-center csb-title'>
                                                                                        <div className='d-flex'><h5>{val.store_cash_discount} OFF</h5></div>
                                                                                    </div>)
                                                                                }
                                                                            } else if (val.deal_master_type === 'free') {
                                                                                return (<div className='d-flex align-center csb-title'>
                                                                                    <div className='d-flex'><h5 className="text-danger">{val.free_item}</h5></div>
                                                                                </div>)
                                                                            }
                                                                        })()}
                                                                        <div className="title-box"><h5>{val.listing_title}</h5></div>
                                                                        <div className='cd-loc mt-2'>
                                                                            <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/pinpoint.webp'} className="img-fluid" alt="pinpoint" />
                                                                            <h6>{val.address}</h6>
                                                                        </div>
                                                                    </div>
                                                                </Link>
                                                                <div className='dd-ld-box cd-ld-box'>
                                                                    <Dropdown drop="up" onSelect={(eventKey) => handleLikeDislike(eventKey, val.deal_id, 'like')}>
                                                                        <Dropdown.Toggle className={`dd-like-box ${val.is_liked ? "like-box-bg" : "dlike-box-bg"}`} variant="success" id="dropdown-like">
                                                                            <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/like.webp'} className="img-fluid" alt="like" />
                                                                            <h6>{val.total_like}</h6>
                                                                        </Dropdown.Toggle>

                                                                        <Dropdown.Menu className='dd-like-drop'>
                                                                            {val.like.map((val1, index1) => {
                                                                                return (
                                                                                    <Dropdown.Item className={val1.is_liked ? 'active-like' : ''} eventKey={val1.id}><div><Image src={process.env.REACT_APP_BASE_URL + 'assets/images/like.webp'} className="img-fluid" alt="like" /> {val1.name} </div><span>{val1.like_count}</span></Dropdown.Item>
                                                                                );
                                                                            })}

                                                                        </Dropdown.Menu>
                                                                    </Dropdown>
                                                                    <Dropdown drop="up" onSelect={(eventKey) => handleLikeDislike(eventKey, val.deal_id, 'dislike')}>
                                                                        <Dropdown.Toggle className={`dd-dislike-box ${val.is_dis_liked ? "like-box-bg" : "dlike-box-bg"}`} variant="success" id="dropdown-dislike">
                                                                            <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/dislike.webp'} className="img-fluid" alt="dislike" />
                                                                            <h6>{val.total_dis_like}</h6>
                                                                        </Dropdown.Toggle>
                                                                        <Dropdown.Menu className='dd-dislike-drop'>
                                                                            {val.dislike.map((val1, index1) => {
                                                                                return (
                                                                                    <Dropdown.Item className={val1.is_disliked ? 'active-dislike' : ''} eventKey={val1.id} ><div><Image src={process.env.REACT_APP_BASE_URL + 'assets/images/dislike.webp'} className="img-fluid" alt="dislike" /> {val1.name} </div><span>{val1.like_count}</span></Dropdown.Item>
                                                                                );
                                                                            })}
                                                                        </Dropdown.Menu>
                                                                    </Dropdown>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    );
                                                })
                                            )}
                                        </div>
                                    </>
                                )}
                                {(deal.length > 0 || filter !== '' || sortby!=='') && (
                                    <>
                                <Row className='mb-4'>
                                    <Col md={12} className='d-flex justify-content-end'>
                                        <Col xs={12} className='d-flex justify-content-between'>
                                            <div className='filter-box'>
                                                <Dropdown>
                                                    <Dropdown.Toggle variant="success" id="filter">
                                                        <h6>{filter !== ''
                                                            ? filter === 1
                                                              ? 'Price Discount'
                                                              : filter === 2
                                                              ? 'BoGo'
                                                              : filter === 3
                                                              ? 'Store Sale -Store % Discount / Store Rs Discount'
                                                              : filter === 5
                                                              ? 'Free'
                                                              : ''
                                                            : 'All'}</h6>
                                                        <Image src="../assets/images/filter.webp" className="img-fluid" alt="filter" />
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu className='filter-drop'>
                                                        <h4 className='d-none'>Deals Filter</h4> 
                                                        <Dropdown.Item href="#" onClick={() => setFilters('')}> All </Dropdown.Item>                                                           
                                                        <Dropdown.Item href="#" onClick={() => setFilters(1)}> Price Discount </Dropdown.Item>
                                                        <Dropdown.Item href="#" onClick={() => setFilters(2)}> BoGo </Dropdown.Item>
                                                        <Dropdown.Item href="#" onClick={() => setFilters(3)}> Store Sale -Store % Discount / Store Rs Discount</Dropdown.Item>
                                                        <Dropdown.Item href="#" onClick={() => setFilters(5)}> Free </Dropdown.Item>                                                           
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </div>                                                  
                                            <div className='sort-box'>
                                                <Dropdown>
                                                    <Dropdown.Toggle variant="success" id="dropdown-like">
                                                        <h6>
                                                          {sortby !== ''
                                                            ? sortby === 'popular'
                                                              ? 'Popular'
                                                              : sortby === 'price_low'
                                                              ? 'Price (Low → High)'
                                                              : sortby === 'price_high'
                                                              ? 'Price (High → Low)'
                                                              : sortby === 'discount_high'
                                                              ? '% Discount (High → Low)'
                                                              : sortby === 'discount_low'
                                                              ? '% Discount (Low → High)'
                                                              : sortby === 'distance'
                                                              ? 'Distance'
                                                              : ''
                                                            : 'Sort By'}
                                                        </h6>
                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/sort.webp'} className="img-fluid" alt="sort" />
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu className='sort-drop ld-drop'>
                                                        <Dropdown.Item href="#" onClick={() => setSortBy('popular')}> Popular </Dropdown.Item>
                                                        {/*<Dropdown.Item href="#" onClick={() => setSortBy('popular')}> Distance </Dropdown.Item>*/}
                                                        <Dropdown.Item href="#" onClick={() => setSortBy('price_low')}> Price (Low -> High) </Dropdown.Item>
                                                        <Dropdown.Item href="#" onClick={() => setSortBy('price_high')}> Price (High -> Low) </Dropdown.Item>
                                                        <Dropdown.Item href="#" onClick={() => setSortBy('discount_high')}> % Discount (High -> Low) </Dropdown.Item>
                                                        <Dropdown.Item href="#" onClick={() => setSortBy('discount_low')}> % Discount (Low -> High) </Dropdown.Item>
                                                        <Dropdown.Item href="#" onClick={() => setSortBy('distance')}> Distance </Dropdown.Item>
                                                        {/* <Dropdown.Item href="#" onClick={() => setSortBy('free_item')}> Free Items </Dropdown.Item> */}
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </div>
                                        </Col>
                                    </Col>
                                </Row>
                                </>
                                )}
                                {deal.length > 0 && (
                                    <>
                                        <Row>
                                            {deal.map((val, index) => {
                                                const isEven = index % 2 === 0;
                                                return (
                                                    <Col xs={6} sm={6} md={4} lg={6} xl={4} xxl={3} className='cd-single-main'>
                                                        <div className='cd-single-box'>
                                                            {val.deal_tag && (
                                                                isEven ? (
                                                                    <span className="user-gre-label">{val.deal_tag}</span>
                                                                ) : (
                                                                    <span className="user-org-label">{val.deal_tag}</span>
                                                                )
                                                            )}
                                                            <Link to={`/neighbour/deal-details/${val.deal_id}`}>
                                                                {/* <Image src={val.image} className="img-fluid" alt="cdeal1" /> */}

                                                                <Image 
                                                                    src={val.image && val.image !== "" ? val.image : process.env.REACT_APP_BASE_URL + '/assets/images/nif.webp'} 
                                                                    className="img-fluid" 
                                                                    alt="cdeal" 
                                                                />                                                     
                                                                <div>
                                                                    <h6><Link to={`/neighbour/business-details/${val.slug}`}><span className='text-primary'>{val.business_name}</span></Link></h6>

                                                                    {(() => {
                                                                        if (val.deal_master_type === 'specific') {
                                                                            if (val.deal_type === 1) {
                                                                                return (<div className='d-flex align-center csb-title'>
                                                                                    <div className='d-flex'><strike className="me-2"><h5>₹ {val.original_mrp}</h5></strike><h5>₹ {val.sale_price}</h5></div>
                                                                                    <h6 class="peroff">{val.discount}% off</h6>
                                                                                </div>)
                                                                            } else if (val.deal_type === 2) {
                                                                                return (<div className='d-flex align-center csb-title'>
                                                                                    <div className='d-flex'><h5>Buy {val.buy_qty} Get {val.get_qty}</h5></div>
                                                                                </div>)
                                                                            }
                                                                        } else if (val.deal_master_type === 'general') {
                                                                            if (val.deal_type === 3) {
                                                                                return (<div className='d-flex align-center csb-title'>
                                                                                    <div className='d-flex'><h5>{val.store_percent_discount}% OFF</h5></div>
                                                                                </div>)
                                                                            } else if (val.deal_type === 4) {
                                                                                return (<div className='d-flex align-center csb-title'>
                                                                                    <div className='d-flex'><h5>{val.store_cash_discount} OFF</h5></div>
                                                                                </div>)
                                                                            }
                                                                        } else if (val.deal_master_type === 'free') {
                                                                            return (<div className='d-flex align-center csb-title'>
                                                                                <div className='d-flex'><h5 className="text-danger">{val.free_item}</h5></div>
                                                                            </div>)
                                                                        }
                                                                    })()}

                                                                    <div className="title-box"><h5>{val.listing_title}</h5></div>
                                                                    <div className='cd-loc mt-2'>
                                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/pinpoint.webp'} className="img-fluid" alt="pinpoint" />
                                                                        <h6>{val.address}</h6>
                                                                    </div>
                                                                </div>
                                                            </Link>
                                                            <div className='dd-ld-box cd-ld-box'>
                                                                <Dropdown onSelect={(eventKey) => handleLikeDislike(eventKey, val.deal_id, 'like')}>
                                                                    <Dropdown.Toggle className={`dd-like-box ${val.is_liked ? "like-box-bg" : "dlike-box-bg"}`} variant="success" id="dropdown-like">
                                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/like.webp'} className="img-fluid" alt="like" />
                                                                        <h6>{val.total_like}</h6>
                                                                    </Dropdown.Toggle>

                                                                    <Dropdown.Menu className='dd-like-drop'>
                                                                        {val.like.map((val1, index1) => {
                                                                            return (
                                                                                <Dropdown.Item className={val1.is_liked ? 'active-like' : ''} eventKey={val1.id}><div><Image src={process.env.REACT_APP_BASE_URL + 'assets/images/like.webp'} className="img-fluid" alt="like" /> {val1.name} </div><span>{val1.like_count}</span></Dropdown.Item>
                                                                            );
                                                                        })}
                                                                    </Dropdown.Menu>
                                                                </Dropdown>
                                                                <Dropdown onSelect={(eventKey) => handleLikeDislike(eventKey, val.deal_id, 'dislike')}>
                                                                    <Dropdown.Toggle className={`dd-dislike-box ${val.is_dis_liked ? "like-box-bg" : "dlike-box-bg"}`} variant="success" id="dropdown-dislike">
                                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/dislike.webp'} className="img-fluid" alt="dislike" />
                                                                        <h6>{val.total_dis_like}</h6>
                                                                    </Dropdown.Toggle>
                                                                    <Dropdown.Menu className='dd-dislike-drop'>
                                                                        {val.dislike.map((val1, index1) => {
                                                                            return (
                                                                                <Dropdown.Item className={val1.is_disliked ? 'active-dislike' : ''} eventKey={val1.id}><div><Image src={process.env.REACT_APP_BASE_URL + 'assets/images/dislike.webp'} className="img-fluid" alt="dislike" /> {val1.name} </div><span>{val1.like_count}</span></Dropdown.Item>
                                                                            );
                                                                        })}
                                                                    </Dropdown.Menu>
                                                                </Dropdown>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                );
                                            })}
                                        </Row>
                                        {current_page !== last_page ? (
                                          <Row className="text-center load-more">
                                            <Col md={12}>
                                              <Link to="#" className="blue-link" onClick={getdeal}>
                                                Load More
                                              </Link>
                                            </Col>
                                          </Row>
                                        ) : (
                                          nearbycitystatus===1 && step===false && (
                                            <Row className="text-center ">
                                              <Col md={12}>
                                                <p>
                                                  All deals viewed! Want to explore nearby towns?{' '}
                                                  <Link to="#" onClick={getNearby}>Click here</Link>
                                                </p>
                                              </Col>
                                            </Row>
                                          )
                                        )}
                                    </>
                                )}

                                {loading === false && exclusivedeal.length <= 0 && deal.length <= 0 && (<><Row className='nodeal'>
                                    <Col className="mt-4 mb-3">
                                        <h3>No deals in yet — but we're coming soon!</h3>
                                        <p>Own a local business or know someone? Register your business free, go online in a minute, and grow locally by offering deals today. <Link to="/business/register">Click to Register</Link></p>
                                    </Col>
                                </Row></>)}
                                {loading === false && exclusivedeal.length <= 0 && deal.length <= 0 && nearbycitystatus===1 && step===false  && (<>
                                    <Row className="text-center ">
                                      <Col md={12}>
                                        <p>
                                          All deals viewed! Want to explore nearby towns?{' '}
                                          <Link to="#" onClick={getNearby}>Click here</Link>
                                        </p>
                                      </Col>
                                    </Row>
                                </>)}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            <Footer />
            {loading && (
                <div className="loadingClass">
                    <img src={loader} alt="loader" />
                </div>
            )}
        </>
    )
}

export default Home;